import type { RiskLevel } from "../../types";

/**
 * Risk-level colour for a node or connection chip. Shown only once the map has
 * been checked: before that the tint would give the answer away (risk level and
 * risky-ness correlate too closely, balance analysis 2026-09-10 §2), so the
 * player has to read "Чем рискует" and the connections instead.
 */
export function riskTintClass(
  classes: Readonly<Record<RiskLevel, string | undefined>>,
  level: RiskLevel,
  submitted: boolean,
): string | undefined {
  return submitted ? classes[level] : undefined;
}
